import {ConfigurationState} from '../storage/ConfigurationState';
import {SearchController} from './SearchController';
import {log} from './LogController';

export class AnalyticsController {
  static logDetail(slug: string) {
    log(this.name, 'logDetail', slug);

    // Matomo tracking
    if (typeof window._paq !== 'undefined') {
      window._paq.push(
        [
          'trackEvent',
          'Element interactions',
          'linkToCompanyDetail',
          ConfigurationState.configuration.siteName,
        ],
      );

      window._paq.push(
        [
          'trackEvent',
          'Element interactions',
          'showDetailPage',
          window.location.pathname,
        ],
      );
    }

    // log to backend
    if (SearchController.urls.hasOwnProperty('json')) {
      const formData = new FormData();
      formData.append('log[siteName]', ConfigurationState.configuration.siteName);
      formData.append('log[action]', 'detail');
      formData.append('log[slug]', slug);
      formData.append('actions[]', 'dropData');
      formData.append('rules[condition]', 'AND');
      formData.append('rules[rules][0][field]', 'slug');
      formData.append('rules[rules][0][operator]', 'equals');
      formData.append('rules[rules][0][value]', slug);
      formData.append('rules[rules][1][field]', 'active');
      formData.append('rules[rules][1][operator]', 'equals');
      formData.append('rules[rules][1][value]', '1');

      fetch(
        <string>SearchController.urls.json,
        {
          method: 'POST',
          body: formData,
        },
      )
        .then();
    }
  }

  static logOutgoingLink(slug: string, siteUrl: string) {
    log(this.name, 'logOutgoingLink', slug, siteUrl);

    // Matomo tracking
    if (typeof window._paq !== 'undefined') {
      window._paq.push(
        [
          'trackEvent',
          'Element interactions',
          'clickOutgoingLinkDetail',
          ConfigurationState.configuration.siteName,
        ],
      );
    }

    // log to backend
    if (SearchController.urls.hasOwnProperty('json')) {
      const formData = new FormData();
      formData.append('log[siteName]', ConfigurationState.configuration.siteName);
      formData.append('log[action]', 'detailOutgoing');
      formData.append('log[slug]', slug);
      formData.append('actions[]', 'dropData');
      formData.append('rules[condition]', 'AND');
      formData.append('rules[rules][0][field]', 'slug');
      formData.append('rules[rules][0][operator]', 'equals');
      formData.append('rules[rules][0][value]', slug);
      formData.append('rules[rules][1][field]', 'active');
      formData.append('rules[rules][1][operator]', 'equals');
      formData.append('rules[rules][1][value]', '1');

      fetch(
        <string>SearchController.urls.json,
        {
          method: 'POST',
          body: formData,
        },
      ).then(
        () => {
          // Redirect to the URL after logging
          //window.location.href = siteUrl;
        },
      );
    }
  }
}
